export default "__VITE_ASSET__CHg$atlD__"